/**
 * TIPSY TEACHER — Scroll Animations
 * Adds fade-in-up animation to cards as they enter the viewport.
 */
document.addEventListener('DOMContentLoaded', function() {
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tipsy-animate-in');
        }
      });
    }, { threshold: 0.1 });

    var animatedElements = document.querySelectorAll(
      '.tipsy-step-card, .tipsy-product-card, .tipsy-testimonial-card'
    );
    animatedElements.forEach(function(el) {
      el.style.opacity = '0';
      observer.observe(el);
    });
  }
});